export default "__VITE_PUBLIC_ASSET__8ddf1720__"